import { RichTableBlockSchema } from '@blocksuite/affine-model';
import {
  BlockHtmlAdapterExtension,
  type BlockHtmlAdapterMatcher,
} from '@blocksuite/affine-shared/adapters';

const CELL_STYLE =
  'border: 1px solid #e3e2e4; padding: 6px 12px; vertical-align: top;';

/**
 * Emits a real `<table>`. Cells are left open so the walker descends into
 * their blocks and each one's own adapter renders inside the `<td>` — which is
 * how lists, images and callouts survive an HTML export.
 */
export const richTableBlockHtmlAdapterMatcher: BlockHtmlAdapterMatcher = {
  flavour: RichTableBlockSchema.model.flavour,
  toMatch: () => false,
  fromMatch: o => o.node.flavour === RichTableBlockSchema.model.flavour,
  toBlockSnapshot: {},
  fromBlockSnapshot: {
    enter: (_o, context) => {
      context.walkerContext
        .openNode(
          {
            type: 'element',
            tagName: 'table',
            properties: {
              style: 'border-collapse: collapse;',
            },
            children: [],
          },
          'children'
        )
        .openNode(
          {
            type: 'element',
            tagName: 'tbody',
            properties: Object.create(null),
            children: [],
          },
          'children'
        );
    },
    leave: (_o, context) => {
      context.walkerContext.closeNode().closeNode();
    },
  },
};

export const richTableRowBlockHtmlAdapterMatcher: BlockHtmlAdapterMatcher = {
  flavour: 'affine:rich-table-row',
  toMatch: () => false,
  fromMatch: o => o.node.flavour === 'affine:rich-table-row',
  toBlockSnapshot: {},
  fromBlockSnapshot: {
    enter: (_o, context) => {
      context.walkerContext.openNode(
        {
          type: 'element',
          tagName: 'tr',
          properties: Object.create(null),
          children: [],
        },
        'children'
      );
    },
    leave: (_o, context) => {
      context.walkerContext.closeNode();
    },
  },
};

export const richTableCellBlockHtmlAdapterMatcher: BlockHtmlAdapterMatcher = {
  flavour: 'affine:rich-table-cell',
  toMatch: () => false,
  fromMatch: o => o.node.flavour === 'affine:rich-table-cell',
  toBlockSnapshot: {},
  fromBlockSnapshot: {
    enter: (_o, context) => {
      context.walkerContext.openNode(
        {
          type: 'element',
          tagName: 'td',
          properties: { style: CELL_STYLE },
          children: [],
        },
        'children'
      );
    },
    leave: (_o, context) => {
      context.walkerContext.closeNode();
    },
  },
};

export const RichTableBlockHtmlAdapterExtension = BlockHtmlAdapterExtension(
  richTableBlockHtmlAdapterMatcher
);
export const RichTableRowBlockHtmlAdapterExtension = BlockHtmlAdapterExtension(
  richTableRowBlockHtmlAdapterMatcher
);
export const RichTableCellBlockHtmlAdapterExtension = BlockHtmlAdapterExtension(
  richTableCellBlockHtmlAdapterMatcher
);
